import React from 'react';
import { SmartphoneIcon, SignalIcon, CreditCardIcon, ZapIcon, LifeBuoyIcon } from 'lucide-react';
export function TopBanner() {
  const menuItems = [{
    label: 'Coverage',
    icon: SignalIcon
  }, {
    label: 'Pay Bill',
    icon: CreditCardIcon
  }, {
    label: 'Activate',
    icon: ZapIcon
  }, {
    label: 'Support',
    icon: LifeBuoyIcon
  }];
  return <div className="bg-[#111111] text-white py-2 border-b border-white/5 fixed top-0 left-0 right-0 z-[60]" data-id="element-519" data-mp="1iact74wftt9y">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-520" data-mp="1n8morgm2qvw3">
        <div className="flex justify-start sm:justify-end items-center gap-6 sm:gap-8 text-[10px] font-black uppercase tracking-[0.15em] overflow-x-auto no-scrollbar py-1" data-id="element-521" data-mp="1s6y0jwvxjggy">
          {menuItems.map(item => <a key={item.label} href={`#${item.label.toLowerCase().replace(/\s+/g, '-')}`} className="flex items-center gap-2 hover:text-[#13E200] transition-colors duration-200 group" data-id="element-522" data-mp="zhhdzfuzqtsn">
              <item.icon className="w-3 h-3 text-[#13E200] group-hover:scale-110 transition-transform" data-id="element-523" data-mp="2d152ul9bm8zh" />
              {item.label}
            </a>)}
        </div>
      </div>
    </div>;
}